import React from 'react';
import ListItem from './ListItem';
import { Issue } from '~/types';
import { isIssueAwaitingSync } from '~/data/sync/issueQueue';
import { usePendingIssues } from '~/issues/usePendingIssues';

export type ListProps = {
  list: Issue[],
  listClassName?: string
}

export type ListComponent = React.VFC<ListProps>

const List: ListComponent = ({ list, listClassName }) => {
  const { pending, loaded } = usePendingIssues(list.map(item => ({ id: item.id, guid: item.guid })));
  return (
    <>
      {list.map(item => (
        <ListItem
          key={item.id}
          item={item}
          listClassName={listClassName}
          awaitingSync={isIssueAwaitingSync(pending, loaded, item.id, item.guid, item.pendingSync)}
        />
      ))}
    </>
  );
};

export default List
